<img class="mobile-hide menu-bg" [src]="commonService.resource.image.menu_bg_desk" alt="">
<div [className]="commonService.chatExist? 'app-container' : 'app-container-wo'">
    <div class="row m-0">
        <div class="col-md-2 p-0"></div>
        <div class="col-md-3 col-sm-12 p-0 about-container">
            <div class="menu-header menu-header-content py-3 px-4">
                <div class="py-3">
                    <span class="material-icons-outlined cursor" (click)="commonService.goBack()">
                        arrow_back
                    </span>
                </div>
                <div>{{ "becomeAPeerSupport.title" | translate }}</div>
            </div>
        </div>
        <div class="col-md-5 col-sm-12 p-0 about-container">
            <div class="overflow-auto content-scroll about-container">
                <div class="content-card mx-4">
                    <div class="content-body" [innerHTML]="'becomeAPeerSupport.content' | translate"></div>
                </div>
            </div>
        </div>
        <div class="col-md-2 p-0"></div>
    </div>
</div>
